import { render, staticRenderFns } from "./PearlReport1920.vue?vue&type=template&id=8d6495c2&scoped=true"
import script from "./PearlReport1920.vue?vue&type=script&lang=js"
export * from "./PearlReport1920.vue?vue&type=script&lang=js"
import style0 from "./PearlReport1920.vue?vue&type=style&index=0&id=8d6495c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6495c2",
  null
  
)

export default component.exports